export const CREATE_ACCOUNT_CONTACT_URL = 'account/{accountId}/account-contact';
export const UPDATE_ACCOUNT_CONTACT_URL = 'account/{accountId}/account-contact/{accountContactId}';
export const ACCOUNT_CONTACTS_LIST_URL = 'account/{accountId}/account-contact/list';